/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AnalyticsDashboardDTOFromJSON, OrderDashboardDTOFromJSON, } from '../models/index';
/**
 *
 */
export class AnalyticsControllerApi extends runtime.BaseAPI {
    /**
     */
    async getDashboard1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/analytics/dashboard`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AnalyticsDashboardDTOFromJSON(jsonValue));
    }
    /**
     */
    async getDashboard1(initOverrides) {
        const response = await this.getDashboard1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrderDashboardRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'].toISOString().substring(0, 10);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'].toISOString().substring(0, 10);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/analytics/orders`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDashboardDTOFromJSON(jsonValue));
    }
    /**
     */
    async getOrderDashboard(requestParameters = {}, initOverrides) {
        const response = await this.getOrderDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
